var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "base-class",
      class: ["base-cell"],
      attrs: { tabindex: "0" },
    },
    [
      _c("i", {
        class: ["mdi", "mr-2", _vm.params.icon],
        attrs: { size: "1.4rem" },
      }),
      _vm._v(" "),
      _c("span", { class: ["main-value", _vm.mainValueColourClass] }, [
        _vm._v(_vm._s(_vm.formattedDisplayValue)),
      ]),
      _vm._v(" "),
      _c(
        "span",
        { class: ["secondary-value", _vm.secondaryValueColourClass] },
        [_vm._v("\n    " + _vm._s(_vm.formattedSecondaryValue) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }